<!-- <p class="deposit-highlight"><b style="color: #ff591e;font-size: 20px;">* </b>Add funds instantly using supported cards, bank transfers, e-wallets, or local payment options.</p> -->
<div>

  <div class="tabs">
    <button class="active"> {{'DEPOSIT' | translate}}</button>
    <button (click)="goWithdraw()"> {{'CASHOUT' | translate}}</button>
  </div>

  <div class="content">
    <div class="form-container bg_7 p_20">
      <div class="deposit_tittle">

        <button class="deposit-image" (click)="DepositType('Nagad')" [class.activeDP]="DepositTypeName === 'Nagad'">

          <img
            src="https://img.d4040p.com/dp/h5/assets/images/footer/color-black/pay34.png?v=1776751585638&source=mcdsrc"
            alt="Nagad" />
        </button>


        <button class="deposit-image" (click)="DepositType('Bkash')" [class.activeDP]="DepositTypeName === 'Bkash'">

          <img src="https://dazen1.one/form/logo/bkash_a_d5065cf089124743a0daabc196047ad9.svg" alt="bKash" />
        </button>


        <!-- <button class="deposit-image" (click)="DepositType('upay')"
          [class.activeDP]="DepositTypeName === 'upay'">

          <img src="https://dazen1.one/form/logo/bkash_p2p_74e5df7387da4948a6bda46f4a2e81e4.svg" alt="bKash P2P" />
        </button> -->

      </div>

      <div class="form-fields">
        <div class="errorMSG" *ngIf="interFalseRes">
          <i class='fas fa-exclamation-triangle'></i>
          <p>{{interFalseRes}}</p>
        </div>

        <form [formGroup]="formPaykassmaUPI" class="form-content p_l_15" (ngSubmit)="depositPaykassma('CRIPTO')">
          <div class="form-group">
            <input type="number" formControlName="amount" class="styled-input"
              [placeholder]="'AMOUNT_MIN_100_MAX_50000_RUPEES' | translate" min="100"
              (keydown)="preventPlusMinus($event)" />
            <div class="error"
              *ngIf="formPaykassmaUPI.get('amount')?.invalid && formPaykassmaUPI.get('amount')?.touched">
              <small *ngIf="formPaykassmaUPI.get('amount')?.errors?.['required']">
                {{'PLEASE_ENTER_AMOUNT' | translate}}
              </small>
              <small *ngIf="formPaykassmaUPI.get('amount')?.errors?.['min']">
                {{'MINIMUM_AMOUNT_IS_100' | translate}}
              </small>
              <small *ngIf="formPaykassmaUPI.get('amount')?.errors?.['max']">
                {{'MAXMIMUM_AMOUNT_IS_50000' | translate}}
              </small>
            </div>
          </div>
          <button type="submit" [disabled]="formPaykassmaUPI.invalid || smallLoader" class="trans_btns">
            <span *ngIf="!smallLoader">{{'DEPOSIT' | translate}}</span>
            <span *ngIf="smallLoader" class="loader-gif">
              <div class="spin">◌</div>
            </span>
          </button>
        </form>
      </div>

    </div>
  </div>




  <ng-container *ngIf="isPopupVisible">
    <div class="popup-overlay" [class.active]="urlSafe">
      <div class="popup-container">
        <div class="popup-header">
          <span class="close-btn" (click)="closeIframe()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </span>
        </div>
        <div class="iframe-wrapper">
          <div class="iframe-loader" *ngIf="!iframeLoaded">
            <img src="../../../assets/siteImg/Loader.gif" alt="Loading..." class="loader-gif" />
          </div>
          <iframe #paymentIframe allow="clipboard-write" scrolling="yes" frameborder="0" allowfullscreen [src]="urlSafe"
            (load)="onIframeLoaded()" [class.loaded]="iframeLoaded"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads">
          </iframe>

        </div>
      </div>
    </div>
  </ng-container>

</div>




<!-- <div class="cover_profile" *ngIf="isSpinner">
  <div class="spin">◌</div>
</div> -->
<div class="marg"></div>